import { useQuery } from "@tanstack/react-query";
import { fetchVacation } from "../../../api/fetchVacations";

export const useVacationQuery = () =>
  useQuery({
    queryKey: ['vacation'],
    queryFn: () => fetchVacation()
  })